import React from 'react';
import moment from 'moment-business-days';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import queryString from 'query-string';
import { rem } from 'polished';
import {
  Tabs,
  Button,
  Loader,
  Icon,
  Segment,
  Link,
  Select,
  Textarea,
} from 'oxyrion-ui/lib';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import { connect, actions } from '../../Store';
import {
  __,
  formatPrice,
  decodeCountry,
  translate,
  getOrderDeliveryDate,
  formatDate,
} from '../../Utils';
import Stepper from '../../Components/Stepper';
import SummaryInfo from '../../Components/SummaryInfo';
import {
  AnimatedFormMessageWrapper,
  OrderInfoPanel,
  LoaderWrapper,
  DarSegment,
  Title,
  FlexBoxStart,
} from '../../Components/ReusableComponents';
import CartProductsTable from '../../Components/CartProductsTable';
import BoxWithLabel from '../../Components/BoxWithLabel';
import AlertPopup from '../../Components/AlertPopup';
import PopUpWrapper from '../../Components/PopUpWrapper';
import CartsCombinator from '../../Components/CartsCombinator';
import API2 from '../../API2';
import TabsSelector from '../../Components/TabsSelector';
import AddNewAddress from '../../Components/AddNewAddress';
import ErrorMessage from '../../Components/ErrorMessage';
// import paymentTypes from '../../ContentConfig/Dashboard/paymentTypes';
// import deliveryTypes from '../../ContentConfig/Dashboard/deliveryTypes';
import RadioGroup from '../../Components/RadioGroup';
import DeliveryDateChange from '../../Components/DeliveryDateChange';
// import OrderImport from '../../Components/OrderImport';
import CheckAccess from '../../ACL/CheckAccess';
import VouchersSelector from '../../Components/VouchersSelector';
import OrderImport from '../../Components/OrderImport';

// const NavozovaKampanInfo = styled.div`
//   font-size: 16px;
//   color: red;
//   margin-bottom: 20px;
//   font-weight: bold;
// `;

const Text = styled.div`
  font-weight: 500;
  margin-right: ${rem(15)};
`;

const MaintContainer = styled.div`
  padding: ${rem(16)};
`;

const Step3Body = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: ${rem(10)};
`;

const NextStepWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: ${rem(25)};
`;

const SecondStepButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const FinishOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Contact = styled.div`
  font-weight: 700;
`;

const CustomIconWrapper = styled.div`
  width: ${rem(40)};
  height: ${rem(40)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${rem(5)};
`;

const Step3ButtonWrapper = styled.div`
  margin-top: ${rem(10)};
  width: ${rem(100)};
  border-top: ${rem(1)} solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(10)};
`;

const DeleteCartWrapper = styled.div`
  float: right;
  cursor: pointer;
  padding: 7px;
  margin: 3px;
  background: #c50303;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`;

const DesktopCartSelector = styled(React.Fragment)`
  margin-bottom: ${rem(20)};
`;

// const AddCartWrapper = styled.div`
//   display: flex;
//   position: absolute;
//   top: 165px;
//   right: 0px;
//   margin-bottom: ${rem(15)};
//   cursor: pointer;
//   width: ${rem(200)};
//   &:hover {
//     text-decoration: underline;
//   }
// `;

const MobileCartSelector = styled.div`
  margin-top: ${rem(10)};
`;

const CustomSelect = styled(Select)`
  min-width: ${rem(200)};
`;

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTextarea = styled(Textarea)`
  width: 98%;
`;

const MinOrderMessage = styled.div`
  margin: ${rem(10)};
  margin-bottom: ${rem(20)};
  color: #d60303;
`;

const VouchersWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${rem(16)};
`;

class ShoppingCart extends React.Component {
  constructor(props) {
    super(props);
    const deliveryTime = getOrderDeliveryDate();
    // console.log(moment('11:00', 'HH:mm'));
    this.state = {
      actualStep: 1,
      selectedPaymentType: '',
      selectedDeliveryType: '',
      contact: undefined,
      loading: true,
      showChangeAddressPopup: false,
      showAddNewAddressPopup: false,
      showDeleteCartPopup: false,
      showImportOrder: false,
      selectedAddress: 0,
      showDeleteDialog: false,
      deliveryTime,
      userAddresses: [],
      cartDescription: '',
      carts: [],
      activeCart: this.props.activeCart || 0,
      myCart: 0,
      androidCart: 0,
      deliveryTypes: [],
      paymentTypes: [],
      vouchers: [],
      deleteMessage: '',
    };

    moment.locale('sk', {
      months: 'januara_februára_marca_apríla_mája_júna_jula_augusta_septembra_októbra_novembra_decembra'.split(
        '_',
      ),
    });

    actions.setActiveMenuItem('44');
  }

  async componentDidMount() {
    const { actualStep } = this.state;
    const query = this.useQuery(this.props);

    if (
      actualStep !== Number(query.step) &&
      (Number(query.step) === 1 || Number(query.step) === 2)
    ) {
      this.setState({
        actualStep: Number(query.step),
      });
    }
    // this.props.history.push(`/shopping-cart?step=${actualStep}`);
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    const { actualStep } = this.state;
    const query = this.useQuery(nextProps);

    if (
      actualStep !== Number(query.step) &&
      (Number(query.step) === 1 || Number(query.step) === 2)
    ) {
      this.setState({
        actualStep: Number(query.step),
      });
    }
  }

  getPaymentMethodByIndex(index) {
    switch (index) {
      case 3:
        return 'ZAL';
      case 2:
        return 'DOBIERKA';
      default:
        return 'PREVOD';
    }
  }

  getTransportMethodByIndex(index) {
    switch (index) {
      case 3:
        return 'OSOBNE_MT';
      case 2:
        return 'OSOBNE_BA';
      default:
        return 'KURIER';
    }
  }

  useQuery(props) {
    return queryString.parse(props.location.search);
  }

  async fetchCartData(cartId, isMainCart = false) {
    this.setState({
      cartLoading: true,
      showImportOrder: false,
      activeCart: cartId,
      error: '',
      // actualStep: 1,
    });
    try {
      const newCart = await API2.getCartAction(cartId);

      const cart = this.sortProductsByCampaign(newCart);

      if (isMainCart) {
        actions.setCart(newCart);
      }
      this.setState({
        cart,
      });
    } catch (e) {
      switch (e.response.status) {
        case 404:
          this.setState({ error: __('Košík sa nepodarilo nájsť.') });
          break;
        case 403:
          this.setState({ error: __('Nemáte potrebné práva.') });
          break;
        default:
          this.setState({
            error: __('Pri načítavaní dát sa vyskytla chyba.'),
          });
      }
    }

    this.setState({
      cartLoading: false,
    });
  }

  async sendOrder() {
    const {
      customer,
      selectedAddress,
      userAddresses,
      selectedPaymentType,
      selectedDeliveryType,
      deliveryTime,
      activeCart,
      cartDescription,
    } = this.state;
    this.setState({
      loading: true,
    });
    try {
      await API2.postB2BOrderAction({
        body: {
          cart_id: activeCart,
          billing_address: customer.billing_address,
          delivery_address: userAddresses[selectedAddress],
          payment_method: selectedPaymentType,
          transport_method: selectedDeliveryType,
          requested_delivery_date: deliveryTime,
          description: cartDescription,
        },
      });
      this.setState({ error: false });
    } catch (e) {
      switch (e.response.status) {
        case 404:
          this.setState({
            error: __('Váš košík sa nepodarilo nájsť.'),
          });
          break;
        case 403:
          this.setState({ error: __('Nemáte potrebné práva.') });
          break;
        default:
          this.setState({
            error: __('Pri vytváraní objednávky sa vyskytol problém.'),
          });
      }
    }
    this.setState({
      loading: false,
    });
  }

  async fetchData() {
    let { selectedDeliveryType, selectedPaymentType, activeCart } = this.state;
    // let { activeCart } = this.props;
    this.setState({
      loading: true,
      showImportOrder: false,
    });

    try {
      const result = await Promise.all([
        API2.getB2BCustomerAction(),
        API2.getB2BAddresses(),
        API2.getB2BDeliveryTypesAction(),
        API2.getB2BPaymentTypesAction(),
        API2.getOrderSettings(),
        API2.getCartsAction(),
        API2.getB2BCustomerVouchersAction(),
      ]);

      const customer = result[0];
      const b2bAddresses = result[1];
      const deliveryTypes = result[2];
      const paymentTypes = result[3];
      const settings = result[4];
      const vouchers = result[6] ? result[6].vouchers : [];

      let carts = result[5];

      const normalizedVouchers = this.normalizeVoucher(vouchers);

      if (!carts.carts.find(c => c.title.toLowerCase() === 'cart1')) {
        await API2.createCartAction({ body: { title: 'cart1' } });
        carts = await API2.getCartsAction();
      }

      const addresses = [];

      if (b2bAddresses) {
        if (
          b2bAddresses.last_order_delivery_info &&
          b2bAddresses.last_order_delivery_info.delivery_address
        ) {
          addresses.push(
            Object.assign(
              b2bAddresses.last_order_delivery_info.delivery_address,
              {
                postal_code:
                  b2bAddresses.last_order_delivery_info.delivery_address
                    .postal_code,
              },
            ),
          );
        }

        if (
          b2bAddresses.last_order_delivery_info &&
          b2bAddresses.last_order_delivery_info.payment_method
        ) {
          selectedPaymentType =
            b2bAddresses.last_order_delivery_info.payment_method;
        } else {
          selectedPaymentType = paymentTypes.payment_types.length
            ? paymentTypes.payment_types[0]._id
            : '';
        }

        if (
          b2bAddresses.last_order_delivery_info &&
          b2bAddresses.last_order_delivery_info.transport_method
        ) {
          selectedDeliveryType =
            b2bAddresses.last_order_delivery_info.transport_method;
        } else {
          selectedDeliveryType = deliveryTypes.delivery_types.length
            ? deliveryTypes.delivery_types[0]._id
            : '';
        }
      }

      const userAddresses = this.normalizeCustomerAddresses(
        customer,
        addresses.concat(b2bAddresses.addresses || []),
      );

      if (!carts.carts.find(c => c._id === activeCart)) {
        activeCart = carts.carts.find(
          c => c.title && c.title.toLowerCase() === 'cart1',
        )._id;
      }

      this.fetchCartData(activeCart);

      let AddressIndex = userAddresses.findIndex(
        a => a._id === b2bAddresses.default_address_id,
      );
      if (AddressIndex === -1) {
        AddressIndex = 0;
      }

      this.setState({
        customer,
        carts: carts.carts,
        vouchers: normalizedVouchers,
        activeCart,
        settings,
        deliveryTypes: deliveryTypes.delivery_types.map(t => {
          return {
            id: t._id,
            label: translate(this.props.appLang, t.translations, t.name),
          };
        }),
        selectedDeliveryType,
        paymentTypes: paymentTypes.payment_types.map(t => {
          return {
            id: t._id,
            label: translate(this.props.appLang, t.translations, t.name),
          };
        }),
        selectedPaymentType,
        myCart: carts.carts.find(
          c => c.title && c.title.toLowerCase() === 'cart1',
        )._id,
        androidCart: carts.carts.find(
          c => c.title && c.title.toLowerCase() === 'android',
        )._id,
        userAddresses,
        selectedAddress: AddressIndex,
      });
    } catch (e) {
      console.log(e);

      switch (e.response.status) {
        case 404:
          this.setState({ error: __('Váš košík sa nepodarilo nájsť.') });
          break;
        case 403:
          this.setState({ error: __('Nemáte potrebné práva.') });
          break;
        default:
          this.setState({
            error: __('Pri načítavaní dát sa vyskytla chyba.'),
          });
      }
    }

    this.setState({
      loading: false,
    });
  }

  normalizeVoucher(vouchers) {
    if (!vouchers) {
      return [];
    }
    return vouchers
      .filter(v => v.campaign)
      .map(v => {
        const campaignData = v.campaign && v.campaign.data;
        const code = v.voucher;
        let discounts;
        const validTo = formatDate(moment(campaignData.valid_to));

        if (campaignData.discountType === 'flat') {
          discounts = [
            { valueFrom: 0, discount: Number(campaignData.discount) },
          ];
        } else if (campaignData.discountType === 'progressive') {
          discounts = campaignData.discounts
            .filter(d => Number(d.valueFrom) > 0)
            .map(d => {
              return {
                valueFrom: Number(d.valueFrom),
                discount: Number(d.discountPercent),
              };
            });
        }
        return {
          code,
          discounts,
          validTo,
          withVat: campaignData.discountWithVat,
        };
      });
  }

  voucherLabelByTotalPrice(code, price, priceVAT) {
    const { vouchers } = this.state;
    const voucher = vouchers.find(v => v.code === code);

    if (!voucher) {
      return '';
    }

    const amount = voucher.withVat ? priceVAT.amount : price.amount;

    const { discounts } = voucher;

    const correctDiscounts = discounts
      ? discounts
          .filter(d => d.valueFrom <= amount)
          .sort((a, b) => b.valueFrom - a.valueFrom)
      : [];

    let discountPercent = 0;

    if (correctDiscounts && correctDiscounts[0]) {
      discountPercent = correctDiscounts[0].discount;
    }

    return `-${discountPercent}% - ${code}`;
  }

  async createNewCart() {
    this.setState({
      cartLoading: true,
    });
    const newCart = await API2.createCartAction({
      body: { title: `Objednávka ${this.state.carts.length + 1}` },
    });
    const result = await API2.getCartsAction();
    actions.setCarts(result.carts);
    actions.setActiveCart(newCart._id);

    this.setState({
      cartLoading: false,
      carts: result.carts,
    });
  }

  async combineCarts(to, from) {
    try {
      this.setState({
        cartsCombinationLoading: true,
      });

      const newCarts = await API2.putB2BOrderMergeAction(from, to);

      this.setState({
        carts: newCarts.carts || [],
        cartsCombinationLoading: false,
      });
      actions.setCarts(newCarts.carts);
      window.location = '/shopping-cart';
    } catch (e) {
      this.setState({
        error: __('Objednávky sa nepodarilo spojiť'),
        cartsCombinationLoading: false,
      });
    }
  }

  normalizeCustomerAddresses(customer, b2bAddresses) {
    const { userAddresses } = this.state;

    if (
      customer.billing_address &&
      customer.billing_address.postal_code &&
      customer.billing_address.postal_code.length > 1
    ) {
      userAddresses.push({
        name: customer.name,
        street: customer.billing_address.street,
        postal_code: customer.billing_address.postal_code,
        city: customer.billing_address.city,
        country: customer.billing_address.country,
        contact_person: customer.name,
        phone: customer.mobile,
      });
    }
    if (
      customer.address &&
      customer.address.postal_code &&
      customer.address.postal_code.length > 1
    ) {
      userAddresses.push({
        name: customer.name,
        street: customer.address.street,
        postal_code: customer.address.postal_code,
        city: customer.address.city,
        country: customer.address.country,
        contact_person: customer.name,
        phone: customer.mobile,
      });
    }
    if (
      customer.delivery_address &&
      customer.delivery_address.postal_code &&
      customer.delivery_address.postal_code.length > 1
    ) {
      userAddresses.push({
        name: customer.name,
        street: customer.delivery_address.street,
        postal_code: customer.delivery_address.postal_code,
        city: customer.delivery_address.city,
        country: customer.delivery_address.country,
        contact_person: customer.name,
        phone: customer.mobile,
      });
    }

    b2bAddresses.forEach(address => {
      userAddresses.push({
        name: address.name,
        street: address.street,
        postal_code: address.postal_code,
        city: address.city,
        country: address.country,
        contact_person: customer.name,
        phone: customer.mobile,
        b2bAddress: true,
        _id: address._id,
      });
    });

    return userAddresses;
  }

  changeStep(newStep) {
    this.props.history.push(`/shopping-cart?step=${newStep}`);
    this.setState({
      actualStep: newStep,
    });
  }

  async productQuantityUpdate(value, index) {
    let { cart } = this.state;
    const oldQuantity = cart.items[index].quantity;
    cart.items[index].quantity = value;

    cart.items = cart.items.map(item => {
      if (
        item.payload &&
        item.payload.related_product_id &&
        item.payload.related_product_id === cart.items[index].product_id
      ) {
        return { ...item, quantity: value };
      }
      return item;
    });
    this.setState({
      productQuantityLoading: index,
      cart,
      error: undefined,
    });

    if (cart.items) {
      try {
        const colorCode =
          cart.items[index].color_code !== null
            ? cart.items[index].color_code
            : undefined;
        cart = await API2.putCartProductAction(
          cart._id,
          cart.items[index].product_id,
          {
            body: {
              quantity: value,
              description: cart.items[index].description || '',
              offer_id: cart.items[index].offer_id,
            },
            colorCode,
            isWh010Sale: cart.items[index].is_wh010_sale || false,
          },
        );
        const relatedProducts = cart.items.filter(
          item =>
            item.payload &&
            item.payload.related_product_id &&
            item.payload.related_product_id === item.product_id,
        );

        if (relatedProducts && relatedProducts.length > 0) {
          cart = await API2.getCartAction(cart._id);
        }

        actions.updateCarts(cart);
      } catch (e) {
        cart.items[index].quantity = oldQuantity;
        if (e.response.status === 400) {
          this.setState({
            error: __(
              'Nepodarilo sa zmeniť - pre cenovú ponuku je nastavený minimálny počet kusov',
            ),
          });
        } else {
          this.setState({ error: __('Nepodarilo sa zmeniť počet kusov') });
        }
      }

      const sortedCart = this.sortProductsByCampaign(cart);

      this.setState({
        cart: sortedCart,
      });
    }

    this.setState({
      productQuantityLoading: -1,
    });
  }

  async finishOrder() {
    await this.sendOrder();
    if (this.state.error) {
      this.setState({
        actualStep: 1,
      });
    } else {
      this.setState({
        actualStep: 3,
      });
    }
  }

  toggleChangeAddress() {
    this.setState({
      showChangeAddressPopup: !this.state.showChangeAddressPopup,
    });
  }

  handleChangeAddress(index) {
    this.setState({
      selectedAddress: index,
      showChangeAddressPopup: false,
    });
  }

  toggleAddNewAddress() {
    this.setState({
      showChangeAddressPopup: false,
      showAddNewAddressPopup: !this.state.showAddNewAddressPopup,
    });
  }

  async addNewAddress(address) {
    const { userAddresses } = this.state;

    userAddresses.push(address);

    try {
      await API2.postB2BAddress({
        body: {
          data: {
            name: address.name,
            street: address.street,
            city: address.city,
            postal_code: address.postal_code,
            country: address.country,
            contact_person: address.contact_person,
            phone: address.phone,
          },
        },
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({
      userAddresses,
      showAddNewAddressPopup: false,
      showChangeAddressPopup: true,
    });
  }

  async deleteAddress(index) {
    const { userAddresses } = this.state;
    const addressToDelete = userAddresses[index];

    if (addressToDelete.b2bAddress) {
      try {
        await API2.deleteB2BAddress(addressToDelete.name);
      } catch (e) {
        console.log(e);
      }
    }
  }

  async deleteVoucherFromCart(voucher) {
    try {
      let { cart } = this.state;

      this.setState({
        deleteVoucherLoadingId: voucher,
      });

      cart = await API2.deleteCartVoucherAction(cart._id, {
        body: { voucher },
      });

      actions.updateCarts(cart);
      this.setState({
        cart,
        deleteVoucherLoadingId: null,
      });
    } catch (e) {
      this.setState({
        error: __('Kupón sa nepodarilo odstrániť'),
        addVoucherLoading: false,
        deleteVoucherLoadingId: null,
      });
    }
  }

  async addVoucherToCart(voucher) {
    this.setState({
      addVoucherLoading: true,
    });
    try {
      let { cart } = this.state;

      cart = await API2.postCartVoucherAction(cart._id, {
        body: { voucher },
      });

      actions.updateCarts(cart);
      this.setState({
        cart,
        addVoucherLoading: false,
      });
    } catch (e) {
      if (e.response.status === 404) {
        this.setState({
          error: __('Neplatný zľavový kupón'),
          addVoucherLoading: false,
        });
      } else if (e.response.status === 409) {
        if (e.details.name === 'VOUCHER_IS_ALREADY_IN_CART') {
          this.setState({
            error: __('Zľavový kupón sa už nachádza v košíku'),
            addVoucherLoading: false,
          });
        }
        if (e.details.name === 'VOUCHER_WAS_ALREADY_USED') {
          this.setState({
            error: __('Zľavový kupón už bol využitý'),
            addVoucherLoading: false,
          });
        }
      } else {
        this.setState({
          error: __('Pri vkladaní kupónu nastala chyba'),
          addVoucherLoading: false,
        });
      }
    }
  }

  deleteProduct(index) {
    const { cart } = this.state;
    const deleteMessage = cart.items[index].configuration_id
      ? __('Naozaj si želáte odstrániť produkty konfigurácie sprejov z košíka?')
      : __('Naozaj si želáte odstrániť produkt z košíka?');
    this.setState({
      showDeleteDialog: true,
      deleteMessage,
      productToDelete: this.state.cart.items[index],
    });
  }

  deleteRelatedProduct(index, relatedIndex) {
    this.setState({
      showDeleteDialog: true,
      productToDelete: this.state.cart.items[index].relatedProducts[
        relatedIndex
      ],
    });
  }

  closeDeleteDialog() {
    this.setState({
      showDeleteDialog: false,
      productToDelete: null,
    });
  }

  async submitDeleteProduct() {
    this.setState({
      showDeleteDialog: false,
      cartLoading: true,
    });
    let { cart } = this.state;
    const { productToDelete } = this.state;

    if (productToDelete) {
      if (productToDelete.configuration_id) {
        try {
          cart = await API2.deleteCartConfigurationProductAction(
            cart._id,
            productToDelete.configuration_id,
          );
          actions.updateCarts(cart);

          const newCart = this.sortProductsByCampaign(cart);

          this.setState({
            productToDelete: null,
            showDeleteDialog: false,
            cart: newCart,
          });
          if (cart && cart.title && cart.title.toLowerCase() === 'cart1') {
            actions.updateCarts(cart);
          }
        } catch (e) {
          console.log(e);
          this.setState({
            error: __('Nepodarilo sa odstrániť produkt z košíka'),
          });
        }
      } else {
        try {
          cart = await API2.deleteCartProductAction(
            cart._id,
            productToDelete.product_id,
            {
              colorCode: productToDelete.color_code || undefined,
              isWh010Sale: productToDelete.is_wh010_sale || false,
              campaignProduct:
                productToDelete.payload &&
                productToDelete.payload.campaignProduct,
              offerId: productToDelete.offer_id || undefined,
            },
          );
          actions.updateCarts(cart);

          const newCart = this.sortProductsByCampaign(cart);

          this.setState({
            productToDelete: null,
            showDeleteDialog: false,
            cart: newCart,
          });
          if (cart.title.toLowerCase() === 'cart1') {
            actions.updateCarts(cart);
          }
        } catch (e) {
          console.log(e);
          this.setState({
            error: __('Nepodarilo sa odstrániť produkt z košíka'),
          });
        }
      }
    }
    this.setState({
      cartLoading: false,
    });
  }

  handlePaymentTypes(id) {
    this.setState({
      selectedPaymentType: id,
    });
  }

  handleDeliveryTypes(id) {
    this.setState({
      selectedDeliveryType: id,
    });
  }

  sortProductsByCampaign(cart) {
    const relatedProducts = cart.items.filter(
      r => r.payload && r.payload.related_product_id && !r.payload.deleted,
    );
    const notRelatedProducts = cart.items.filter(
      r => !(r.payload && r.payload.related_product_id),
    );

    const sortedItems = [];

    notRelatedProducts.forEach(item => {
      sortedItems.push(
        Object.assign(item, {
          relatedProducts: relatedProducts.filter(
            r => r.payload.related_product_id === item.product_id,
          ),
        }),
      );
    });

    const newCart = Object.assign({}, cart);
    newCart.items = this.groupProductsByConfiguration(sortedItems);

    return newCart;
  }
  groupProductsByConfiguration(items) {
    return items.sort((a, b) => {
      if (a.configuration_id < b.configuration_id) {
        return -1;
      }
      if (a.configuration_id > b.configuration_id) {
        return 1;
      }
      return 0;
    });
  }

  async handleDescriptionChange(value, productId, colorCode) {
    const { cart } = this.state;

    cart.items.find(
      i =>
        i.product_id === productId &&
        i.configuration_id == null &&
        i.color_code === (colorCode || null),
    ).description = value;

    this.setState({
      descriptionSaveLoading: true,
      cart,
    });

    const product = cart.items.find(
      i => i.product_id === productId && i.configuration_id == null,
    );

    const newCart = await API2.putCartProductDescAction(cart._id, productId, {
      body: {
        description: value,
        quantity: product.quantity,
      },
      offerId: product.offer_id,
      isWh010Sale: product.is_wh010_sale || false,
      colorCode,
    });
    this.setState({
      cart: newCart,
      descriptionSaveLoading: false,
    });
  }

  async deleteActiveCart() {
    const { activeCart } = this.state;

    this.setState({
      loading: true,
      activeCart: this.state.myCart,
    });
    try {
      await API2.deleteCartAction(activeCart);
      // this.fetchData();
      window.location = '/shopping-cart';
    } catch (e) {
      this.setState({ error: __('Nepodarilo sa vymazať košík') });
    }

    this.setState({
      loading: false,
      showDeleteCartPopup: false,
    });
  }

  toProducts() {
    localStorage.setItem('menuState', false);
    actions.setMenuState(false);
    actions.setActiveCart(this.state.activeCart);
    this.props.history.push('buy/catalog');
  }

  renderUserAddress(address) {
    return (
      <React.Fragment>
        {address.name}
        <br />
        {address.street}
        <br />
        {`${address.postal_code} ${address.city}`}
        <br />
        {decodeCountry(address.country)}
        <br />
        <br />
        <Contact>{__('Kontaktná osoba:')}</Contact>
        <br />
        {address.contact_person}
        <br />
        {address.phone}
      </React.Fragment>
    );
  }

  renderCart() {
    const { user } = this.props;
    const {
      actualStep,
      customer,
      contact,
      userAddresses,
      selectedAddress,
      cart,
      selectedPaymentType,
      selectedDeliveryType,
      productQuantityLoading,
      deliveryTime,
      cartLoading,
      myCart,
      androidCart,
      activeCart,
      cartDescription,
      descriptionSaveLoading,
      deliveryTypes,
      paymentTypes,
      settings,
      addVoucherLoading,
      deleteVoucherLoadingId,
    } = this.state;

    const minPrice =
      settings && settings.min_order
        ? settings.min_order.find(m => m.lang === user.firm || 'SK').value
        : 0;

    const products =
      cart &&
      cart.items &&
      cart.items.filter(item => !(item.payload && item.payload.deleted));

    const person = contact || this.props.user;

    if (cartLoading) {
      return (
        <LoaderWrapper style={{ width: '100%' }}>
          <Loader size="xl" />
        </LoaderWrapper>
      );
    }
    return (
      <div style={{ width: '100%' }}>
        {myCart !== activeCart && androidCart !== activeCart && (
          <DeleteCartWrapper
            onClick={() => {
              this.setState({
                showDeleteCartPopup: true,
              });
            }}
            title={__('Odstrániť objednávku')}
          >
            <Icon name="trash" size="m" color="white" />
          </DeleteCartWrapper>
        )}

        <Stepper
          steps={[
            {
              title: __('Košík'),
              id: 1,
            },
            {
              title: __('Dodanie, platba, potvrdenie'),
              id: 2,
            },
          ]}
          selected={actualStep}
          onStepClick={e =>
            products && products.length === 0 ? {} : this.changeStep(e)
          }
        />
        <AnimatedFormMessageWrapper display={actualStep === 2}>
          <OrderInfoPanel>
            <BoxWithLabel
              icon="article"
              header={__('Fakturačné údaje')}
              component={
                customer &&
                customer.billing_address && (
                  <React.Fragment>
                    {customer.name || ' - '}
                    <br />
                    {customer.billing_address.street || ' - '}
                    <br />
                    {`${customer.billing_address.postal_code} ${customer
                      .billing_address.city || ' - '}`}
                    <br />
                    {decodeCountry(customer.billing_address.country) || ' - '}
                    <br />
                    <br />
                    {`${__('IČO')}: ${customer.registration_no}` || ' - '}
                    <br />
                    {`${__('DIČ')}: ${customer.vat_nr}` || ' - '}
                    <br />
                    {`${__('IČ DPH')}: ${customer.vat_nr}` || ' - '}
                  </React.Fragment>
                )
              }
            />
            <BoxWithLabel
              icon="mail"
              header={__('Adresa doručenia')}
              component={
                userAddresses[selectedAddress] ? (
                  <React.Fragment>
                    {userAddresses[selectedAddress].name || ' - '}
                    <br />
                    {userAddresses[selectedAddress].street || ' - '}
                    <br />
                    {`${userAddresses[selectedAddress].postal_code ||
                      ' - '} ${userAddresses[selectedAddress].city || ' - '}`}
                    <br />
                    {decodeCountry(userAddresses[selectedAddress].country) ||
                      ' - '}
                    <br />
                    <br />
                    <Button primary onClick={() => this.toggleChangeAddress()}>
                      {__('Zmeniť')}
                    </Button>
                    <br />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Button primary onClick={() => this.toggleChangeAddress()}>
                      {__('Zmeniť')}
                    </Button>
                    <br />
                  </React.Fragment>
                )
              }
            />
            <BoxWithLabel
              icon="user"
              header={__('Osoba')}
              component={
                person && (
                  <React.Fragment>
                    {`${person.name} ${person.surname}` || ' - '}
                    <br />
                    {`${person.email}` || ' - '}
                    <br />
                    {`${person.mobile}` || ' - '}
                    <br />
                  </React.Fragment>
                )
              }
            />
            <BoxWithLabel
              icon="wallet"
              header={__('Platba')}
              background={baseTheme.color.primaryBg}
              component={
                <RadioGroup
                  radios={paymentTypes}
                  selectedId={selectedPaymentType}
                  onChange={id => this.handlePaymentTypes(id)}
                />
              }
            />
            <BoxWithLabel
              icon="deliveryTruck"
              header={__('Doprava')}
              background={baseTheme.color.primaryBg}
              component={
                <React.Fragment>
                  <RadioGroup
                    radios={deliveryTypes}
                    selectedId={selectedDeliveryType}
                    onChange={id => this.handleDeliveryTypes(id)}
                  />
                  {cart &&
                    cart.total_price &&
                    cart.total_price.amount < minPrice && (
                      <MinOrderMessage>
                        {`${__('Vaša objednávka je menšia ako')} ${formatPrice({
                          amount: minPrice,
                          currency:
                            cart && cart.total_price
                              ? cart.total_price.currency
                              : 'SK',
                        })} bez DPH. ${__(
                          'Doprava je zdarma, ak túto hodnotu prekročíte navýšením objednávky',
                        )}.`}
                      </MinOrderMessage>
                    )}
                </React.Fragment>
              }
            />
          </OrderInfoPanel>
        </AnimatedFormMessageWrapper>
        <AnimatedFormMessageWrapper display={actualStep === 2}>
          <DarSegment padding={rem(10)}>
            <CustomIconWrapper>
              <Icon name="clock" color="white" size="l" />
            </CustomIconWrapper>
            <div style={{ marginRight: rem(10) }}>
              {`${__('Predbežný dátum dodania:')} ${deliveryTime.format(
                'Do. MMMM YYYY',
              )} `}
            </div>

            <Button
              primary
              onClick={() => {
                this.setState({
                  showDeliveryTimeDialog: true,
                });
              }}
            >
              {__('Zmeniť')}
            </Button>
          </DarSegment>
        </AnimatedFormMessageWrapper>
        {products && products.length > 0 && (
          <CartProductsTable
            products={products}
            vouchers={
              cart.vouchers
                ? cart.vouchers.map(v =>
                    this.voucherLabelByTotalPrice(
                      v,
                      cart.total_price,
                      cart.total_price_vat,
                    ),
                  )
                : []
            }
            quantityHandler={(value, index) =>
              this.productQuantityUpdate(value, index)
            }
            descriptionHandler={(e, productId, colorCode) =>
              this.handleDescriptionChange(e, productId, colorCode)
            }
            readOnly={actualStep !== 1}
            deleteProduct={index => this.deleteProduct(index)}
            deleteRelatedProduct={(index, relatedIndex) =>
              this.deleteRelatedProduct(index, relatedIndex)
            }
            productQuantityLoading={productQuantityLoading}
          />
        )}
        {cart && (
          <React.Fragment>
            <VouchersWrapper>
              <div style={{ width: rem(500) }}>
                <VouchersSelector
                  vouchers={cart.vouchers}
                  onDelete={voucher => this.deleteVoucherFromCart(voucher)}
                  onAdd={voucher => this.addVoucherToCart(voucher)}
                  addLoading={addVoucherLoading}
                  deleteLoadingId={deleteVoucherLoadingId}
                />
              </div>
            </VouchersWrapper>

            <SummaryInfo
              data={[
                {
                  title: 'Spolu bez DPH:',
                  value: formatPrice(cart.total_price),
                },
                {
                  title: 'DPH:',
                  value: formatPrice({
                    amount:
                      cart.total_price_vat.amount - cart.total_price.amount,
                    currency: cart.total_price.currency,
                  }),
                },
                {
                  title: 'Spolu na úhradu:',
                  value: formatPrice(cart.total_price_vat),
                  highLine: true,
                },
              ]}
            />
            {actualStep === 2 && (
              <BoxWithLabel
                header={__('Poznámka k objednávke')}
                component={
                  person && (
                    <React.Fragment>
                      <StyledTextarea
                        value={cartDescription}
                        placeholder={__('Sem zadajte poznámku (max 50 znakov)')}
                        maxLength={50}
                        onChange={e =>
                          this.setState({
                            cartDescription: e.target.value,
                          })
                        }
                      />
                    </React.Fragment>
                  )
                }
              />
            )}
          </React.Fragment>
        )}

        <NextStepWrapper>
          {actualStep === 1 ? (
            <React.Fragment>
              <Text>
                {__(
                  'V nasledujúcom kroku potvrdíte fakturačné, dodacie údaje, spôsob platby',
                )}
              </Text>
              <Button
                onClick={() => this.changeStep(2)}
                primary
                disabled={products && products.length === 0}
              >
                {__('Pokračovať')}
              </Button>
            </React.Fragment>
          ) : (
            <SecondStepButtonsWrapper>
              <Button onClick={() => this.changeStep(1)}>{__('Späť')}</Button>
              <CheckAccess
                operation="postB2BOrderAction"
                Component={
                  <FinishOrderWrapper>
                    <Button
                      onClick={() => this.finishOrder()}
                      loading={descriptionSaveLoading}
                      disabled={descriptionSaveLoading}
                      primary
                    >
                      {__('Potvrdiť objednávku *')}
                    </Button>
                    {`*-${__('objednávka s povinnosťou platby')}`}
                  </FinishOrderWrapper>
                }
              />
            </SecondStepButtonsWrapper>
          )}
        </NextStepWrapper>
      </div>
    );
  }

  render() {
    const {
      showChangeAddressPopup,
      showAddNewAddressPopup,
      showDeleteCartPopup,
      showImportOrder,
      userAddresses,
      selectedAddress,
      loading,
      showDeleteDialog,
      showDeliveryTimeDialog,
      deliveryTime,
      error,
      actualStep,
      carts,
      activeCart,
      myCart,
      showOrderCombine,
      cartsCombinationLoading,
      deleteMessage,
    } = this.state;

    if (loading) {
      return (
        <LoaderWrapper style={{ width: '100%' }}>
          <Loader size="xl" />
        </LoaderWrapper>
      );
    }

    if (actualStep === 3) {
      return (
        <Segment secondary>
          <Title>{__('Ďakujeme za objednávku')}</Title>
          <Step3Body>
            <div>
              {__('Na e-mailovú adresu ')}
              <Link>{this.props.user.email}</Link>
              {__(
                ' sme odoslali potvrdenie objednávky. Budeme vás informovať o jej spracovaní.',
              )}
            </div>
            <Link>{__('Sledovať zásielku')}</Link>
            <Step3ButtonWrapper>
              {' '}
              <Button
                primary
                onClick={() => {
                  window.location = '/shopping-cart';
                }}
              >
                {__('Návrat')}
              </Button>
            </Step3ButtonWrapper>
          </Step3Body>
        </Segment>
      );
    }

    const cartsForCombinator = carts;

    return (
      <MaintContainer>
        <PopUpWrapper
          display={showAddNewAddressPopup}
          message={__('Pridanie doručovacej adresy')}
          customWidth={360}
          onClose={() => this.toggleAddNewAddress()}
          onEscClose={() => this.toggleAddNewAddress()}
        >
          <AddNewAddress onAdd={address => this.addNewAddress(address)} />
        </PopUpWrapper>

        <PopUpWrapper
          display={showOrderCombine}
          message={__('Spojiť objednávky')}
          small
          onClose={() =>
            this.setState({
              showOrderCombine: false,
            })
          }
          onEscClose={() =>
            this.setState({
              showOrderCombine: false,
            })
          }
        >
          <div>
            {activeCart && (
              <CartsCombinator
                carts={cartsForCombinator}
                activeCart={activeCart}
                loading={cartsCombinationLoading}
                onConfirm={(to, from) => this.combineCarts(to, from)}
              />
            )}
          </div>
        </PopUpWrapper>

        <AlertPopup
          display={showImportOrder}
          alignUnderHeader
          onClose={() =>
            this.setState({
              showImportOrder: false,
            })
          }
          component={
            <OrderImport
              toCart={() => {
                this.fetchData();
                // window.location = '/shopping-cart';
              }}
              onSuccess={cart => {
                if (cart && cart.cartId) {
                  this.setState({
                    activeCart: cart.cartId,
                  });
                }
              }}
            />
          }
        />

        <AlertPopup
          display={showDeleteDialog}
          onClose={() => this.closeDeleteDialog()}
          onDismiss={() => this.closeDeleteDialog()}
          onSubmit={() => this.submitDeleteProduct()}
          alert
          alignUnderHeader
          text={deleteMessage}
          styles={{ background: 'white' }}
        />

        <AlertPopup
          display={showDeleteCartPopup}
          onClose={() =>
            this.setState({
              showDeleteCartPopup: false,
            })
          }
          onDismiss={() =>
            this.setState({
              showDeleteCartPopup: false,
            })
          }
          onSubmit={() => this.deleteActiveCart()}
          alert
          alignUnderHeader
          text={__('Naozaj si želáte vymazať košík?')}
          styles={{ background: 'white' }}
        />

        <AlertPopup
          display={showChangeAddressPopup}
          alignUnderHeader
          onClose={() => this.toggleChangeAddress()}
          scrollContent
          component={
            <TabsSelector
              title={__('Výber doručovacej adresy')}
              contents={userAddresses.map(address => {
                return this.renderUserAddress(address);
              })}
              addTitle={__('NOVÁ ADRESA DORUČENIA')}
              selected={selectedAddress}
              onSelect={e => this.handleChangeAddress(e)}
              onAddNew={() => this.toggleAddNewAddress()}
              onDelete={index => this.deleteAddress(index)}
            />
          }
        />

        <PopUpWrapper
          display={showDeliveryTimeDialog}
          customWidth={500}
          message={__('Zmena dátumu dodania')}
          onClose={() =>
            this.setState({
              showDeliveryTimeDialog: false,
            })
          }
          onEscClose={() =>
            this.setState({
              showDeliveryTimeDialog: false,
            })
          }
        >
          <DeliveryDateChange
            label={deliveryTime.format('Do. MMMM YYYY')}
            value={deliveryTime}
            lowestDeliveryDate={getOrderDeliveryDate()}
            onSubmit={newDeliveryTime =>
              this.setState({
                deliveryTime: newDeliveryTime,
                showDeliveryTimeDialog: false,
              })
            }
          />
        </PopUpWrapper>

        <ErrorMessage display={error} text={error} />

        {/* {this.props.user.customer.customer_type === 'B2B' && (
          <NavozovaKampanInfo>
            {__(
              'Práve prebieha jarná návozová kampaň. Nezabudnite si do objednávky vložiť svoj zľavový kód, ktorý nájdete v sekcii Novinky - Prebiehajúce kampane',
            )}
          </NavozovaKampanInfo>
        )} */}
        {carts.length > 0 && (
          <React.Fragment>
            {window.innerWidth >= 1000 &&
            carts.length * 150 < window.innerWidth ? (
              <DesktopCartSelector>
                <Tabs
                  activeTab={{
                    id: activeCart,
                  }}
                  onChange={tab => {
                    this.fetchCartData(
                      tab.id,
                      tab.title.toLowerCase() === 'cart1',
                    );
                  }}
                  onAddClick={() => {
                    this.createNewCart();
                  }}
                >
                  <Tabs.Tab id={myCart} title={__('Moja objednávka')}>
                    {this.renderCart()}
                  </Tabs.Tab>
                  {carts
                    .filter(c => c.title && c.title.toLowerCase() !== 'cart1')
                    .map(cart => {
                      if (
                        cart.title === 'android' &&
                        (!cart.items || cart.items.length <= 0)
                      ) {
                        return <React.Fragment />;
                      }
                      return (
                        <Tabs.Tab
                          id={cart._id}
                          title={
                            cart.title === 'android'
                              ? __('Mobilná aplikácia')
                              : cart.title
                          }
                        >
                          {this.renderCart()}
                        </Tabs.Tab>
                      );
                    })}
                </Tabs>
              </DesktopCartSelector>
            ) : (
              <MobileCartSelector>
                <SelectWrapper>
                  <CustomSelect
                    size="s"
                    icon="arrow-down"
                    iconRight
                    onChange={e => {
                      this.fetchCartData(e.target.value);
                    }}
                  >
                    {carts.map(cart => (
                      <option
                        value={cart._id}
                        selected={cart._id === activeCart}
                      >
                        {cart &&
                        cart.title &&
                        cart.title.toLowerCase() === 'cart1'
                          ? __('Moja objednávka')
                          : cart.title}
                      </option>
                    ))}
                  </CustomSelect>
                  <DeleteCartWrapper
                    style={{ background: 'green' }}
                    title={__('Vytvoriť novú objednávku')}
                    onClick={() => {
                      this.createNewCart();
                    }}
                  >
                    <Icon name="plus" size="m" color="white" />
                  </DeleteCartWrapper>
                </SelectWrapper>
                {this.renderCart()}
              </MobileCartSelector>
            )}
            <FlexBoxStart>
              <Button onClick={() => this.toProducts()} primary>
                {__('Pridať produkt')}
              </Button>
              <div style={{ width: rem(6) }} />
              <Button
                onClick={() =>
                  this.setState({
                    showImportOrder: true,
                  })
                }
                gray
              >
                {__('Importovať objednávku')}
              </Button>
              <div style={{ width: rem(6) }} />
              {cartsForCombinator && cartsForCombinator.length > 1 && (
                <Button
                  onClick={() =>
                    this.setState({
                      showOrderCombine: true,
                    })
                  }
                  gray
                >
                  {__('Zlúčiť objednávky')}
                </Button>
              )}
            </FlexBoxStart>
            {/* <FlexBoxStart style={{ marginTop: rem(15) }}>
              <Button
                onClick={() =>
                  this.setState({
                    showImportOrder: true,
                  })
                }
                gray
              >
                {__('Importovať objednávku')}
              </Button>
            </FlexBoxStart> */}
          </React.Fragment>
        )}
      </MaintContainer>
    );
  }
}

ShoppingCart.propTypes = {
  cart: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({
    email: PropTypes.string,
    mobile: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

ShoppingCart.defaultProps = {};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ShoppingCart);



// WEBPACK FOOTER //
// ./src/Containers/ShoppingCart/index.jsx